import { useOrganisationsContext } from 'contexts';

export const useCurrentOrganisation = () => {
  const { currentOrganisation } = useOrganisationsContext();
  return currentOrganisation;
};
